import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  Snackbar,
  Alert
} from '@mui/material';

const AddCarDialog = ({ open, onClose, onAdd }) => {
  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split('T')[0];
  
  const [carData, setCarData] = useState({
    unitNumber: '',
    make: 'Daihatsu',
    model: 'Granmax Blindvan',
    year: '2020',
    kirExpDate: today,         // Set to today
    stnkExpDate: today,        // Set to today
    licensePlateExpDate: today, // Set to today
    regionalPlate: '',
    ownerName: '',
    bodyColor: 'White',
    myPertaminaCode: ''
  });

  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);

  const carMakes = ['Daihatsu', 'Isuzu'];
  const carModelsByMake = {
    Daihatsu: ['Granmax Blindvan'],
    Isuzu: ['CDE Long', 'CDE']
  };
  const years = Array.from({ length: 12 }, (_, i) => (2020 - i).toString());
  const bodyColors = ['White', 'Black', 'Orange', 'Blue', 'Other'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCarData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'make' && { model: carModelsByMake[value][0] })
    }));
  };

  const handleSubmit = async () => {
    try {
      await onAdd(carData);
      setCarData({
        unitNumber: '',
        make: 'Daihatsu',
        model: 'Granmax Blindvan',
        year: '2020',
        kirExpDate: '',
        stnkExpDate: '',
        licensePlateExpDate: '',
        regionalPlate: '',
        ownerName: '',
        bodyColor: 'White',
        myPertaminaCode: ''
      });
      onClose();
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to add car');
      setShowError(true);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Add New Car</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                name="unitNumber"
                label="Unit Number"
                fullWidth
                required
                value={carData.unitNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                name="make"
                label="Make"
                fullWidth
                required
                value={carData.make}
                onChange={handleChange}
              >
                {carMakes.map((make) => (
                  <MenuItem key={make} value={make}>
                    {make}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                name="model"
                label="Model"
                fullWidth
                required
                value={carData.model}
                onChange={handleChange}
              >
                {carModelsByMake[carData.make].map((model) => (
                  <MenuItem key={model} value={model}>
                    {model}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                name="year"
                label="Year"
                fullWidth
                required
                value={carData.year}
                onChange={handleChange}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="kirExpDate"
                label="KIR Expiration Date"
                type="date"
                fullWidth
                required
                value={carData.kirExpDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="stnkExpDate"
                label="STNK Expiration Date"
                type="date"
                fullWidth
                required
                value={carData.stnkExpDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="licensePlateExpDate"
                label="License Plate Expiration Date"
                type="date"
                fullWidth
                required
                value={carData.licensePlateExpDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="regionalPlate"
                label="Regional License Plate"
                fullWidth
                required
                value={carData.regionalPlate}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="ownerName"
                label="Owner Name"
                fullWidth
                required
                value={carData.ownerName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                name="bodyColor"
                label="Body Color"
                fullWidth
                required
                value={carData.bodyColor}
                onChange={handleChange}
              >
                {bodyColors.map((color) => (
                  <MenuItem key={color} value={color}>
                    {color}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="myPertaminaCode"
                label="MyPertamina Code (Google Drive Link)"
                fullWidth
                required
                value={carData.myPertaminaCode}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Add Car
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={() => setShowError(false)}
      >
        <Alert onClose={() => setShowError(false)} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCarDialog;